import { render, staticRenderFns } from "./AlunoTurma.vue?vue&type=template&id=b29eb462&"
import script from "./AlunoTurma.vue?vue&type=script&lang=js&"
export * from "./AlunoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports